import React from 'react';

import {currency} from "../../../../utils/dashboard-utils";

const toggle = (e) => {
    try{
        var tbodyClasses = e.target.parentElement.parentElement.classList;
        if(tbodyClasses.contains("exp")){
            tbodyClasses.remove("exp");
        }else{
            tbodyClasses.add("exp");
        }
    }catch(err)
    {
        console.log("Error Expanding" ,err);
    }
    
};

const PlanMobile = (props) => {
    if(props){
        return (
            <tbody className="purpose">
                    <tr className="purpose">
                        <td colSpan={2}className="name" onClick={(e) => toggle(e)}>{props.plan.planName}</td>
                    </tr>
                    { props.showYTDColumns ? (
                    <tr>
                        <td className="expData">YTD Distributions</td>
                        <td className="expData distributions-ytd">{currency(props.plan.subTotalDistributionAccountLevel)}</td>
                    </tr>
                    ):null}
                    { props.showYTDColumns ? (
                    <tr>
                        <td className="expData">Remaining for the year</td>
                        <td className="expData remaining-year">{currency(props.plan.subTotalRemainingYearAccountLevel)}</td>
                    </tr>
                    ):null}
                    { props.showYTDColumns ? (
                    <tr>
                        <td className="expData">YTD Tax Withholding</td>
                        <td className="expData tax-ytd">{currency(props.plan.subTotalTaxWithHoldingsAccountLevel)}</td>
                    </tr>
                    ):null}
                    <tr className="purpose btmLine">
                        <td colSpan={2}></td>
                    </tr>
            </tbody>
        );
    }
    return null;
};
export default PlanMobile;